import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const ExpenseTypeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [expenseTypeOptions, setExpenseTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { expenseType, setExpenseType } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setExpenseType(
      parameters?.data?.filter((item) => item.type === "expenseType")
    );
  }, [parameters]);

  useEffect(() => {
    setExpenseTypeOptions(
      expenseType.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }, [expenseType]);

  return (
    <Dropdown
      value={options.value}
      options={expenseTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo de despesa"
      showClear
    />
  );
};
export default ExpenseTypeDropdown;
